<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
    data: () => ({
        banners: [
            {id:1, url : '/assets/images/partners/intelimotor.png'},
            {id:2, url : '/assets/images/partners/maxi.png'},
            {id:3, url : '/assets/images/partners/meta.png'},
            {id:4, url : '/assets/images/partners/seekop.png'},
            {id:5, url : '/assets/images/partners/mercadolibre.png'},
            {id:6, url : '/assets/images/partners/checkmark.png'},
        ],
        swiperOption: {
            invert: true,
            slidesPerView: 3,
            spaceBetween: 10,
            allowTouchMove: false,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            autoplay: {
                delay: 1000,
                disableOnInteraction: false,
            },
        },
        currentSlide: 0,
    }),
    components: {
        Swiper,
        SwiperSlide,
        bannerImg:[],
    },
}
</script>
<template>
    <div class="slider-brands-mobile block md:hidden">
        <swiper
            ref="swiperBannerBrands"
            :options="swiperOption"
            >
            <swiper-slide v-for="(bannerHero, index) in banners" :key="index">
                <div class="swiper-slider-brand-container">
                    <img class="image-slider-brand" :src="bannerHero.url">
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>